import React from "react";
import Radio from "../../CommonComponents/Radio";
import { DISPLAY_TEST_RESULT, libTypeIds } from "../../../constants";

const StudentView = ({ type = libTypeIds.MCQ, onChange, value = 0 }) => {
  return (
    <div className="test-student-view-setting-container">
      <p className="test-student-view-setting-title">
        Choose what students can see after submitting the test:
      </p>
      <div className="test-student-view-setting-options-container">
        <Radio
          text="Show Nothing"
          checked={value === DISPLAY_TEST_RESULT.NONE}
          onChange={(checked) => onChange(checked, DISPLAY_TEST_RESULT.NONE)}
        />
        <Radio
          text="Show final score only"
          checked={value === DISPLAY_TEST_RESULT.SCORE}
          onChange={(checked) => onChange(checked, DISPLAY_TEST_RESULT.SCORE)}
        />
        <Radio
          text="Show questions with chosen answers"
          checked={value === DISPLAY_TEST_RESULT.SUBMISSION}
          onChange={(checked) => onChange(checked, DISPLAY_TEST_RESULT.SUBMISSION)}
        />
        <Radio
          text="Show full details (score, correct & incorrect answers)"
          checked={value === DISPLAY_TEST_RESULT.ALL}
          onChange={(checked) => onChange(checked, DISPLAY_TEST_RESULT.ALL)}
        />
      </div>
    </div>
  );
};

export default StudentView;
